/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkAssetInventoryDocumentReadRequest
 */
export interface MarkAssetInventoryDocumentReadRequest {
    /**
     * 
     * @type {boolean}
     * @memberof MarkAssetInventoryDocumentReadRequest
     */
    isRead: boolean;
}

/**
 * Check if a given object implements the MarkAssetInventoryDocumentReadRequest interface.
 */
export function instanceOfMarkAssetInventoryDocumentReadRequest(value: object): value is MarkAssetInventoryDocumentReadRequest {
    if (!('isRead' in value) || value['isRead'] === undefined) return false;
    return true;
}

export function MarkAssetInventoryDocumentReadRequestFromJSON(json: any): MarkAssetInventoryDocumentReadRequest {
    return MarkAssetInventoryDocumentReadRequestFromJSONTyped(json, false);
}

export function MarkAssetInventoryDocumentReadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkAssetInventoryDocumentReadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isRead': json['isRead'],
    };
}

export function MarkAssetInventoryDocumentReadRequestToJSON(json: any): MarkAssetInventoryDocumentReadRequest {
    return MarkAssetInventoryDocumentReadRequestToJSONTyped(json, false);
}

export function MarkAssetInventoryDocumentReadRequestToJSONTyped(value?: MarkAssetInventoryDocumentReadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isRead': value['isRead'],
    };
}

